import { render, staticRenderFns } from "./bullGroupWiseSemenStock.vue?vue&type=template&id=5ec3dcd8&scoped=true&"
import script from "./bullGroupWiseSemenStock.vue?vue&type=script&lang=js&"
export * from "./bullGroupWiseSemenStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec3dcd8",
  null
  
)

export default component.exports